import {AuthConfig} from 'angular-oauth2-oidc';
import {ConfigUtil} from '@shared/services/config.util';

export const authConfig = ():AuthConfig => {
  return {
    issuer: `${ConfigUtil.get('keycloak')['url']}/realms/${ConfigUtil.get('keycloak')['realm']}`,
    redirectUri: window.location.origin + '/callback',
    clientId: 'uwfactuur',
    responseType: 'code',
    scope: 'openid profile email offline_access',
    showDebugInformation: true,
  };
};
